import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ROOT_REDUCERS } from '@store/app.store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  AuthInterceptor,
  spinnerInterceptor,
  tokenInterceptor,
} from '@core/interceptors';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withHashLocation,
  withComponentInputBinding,
} from '@angular/router';
import { routes } from './app.routes';
import {
  MAT_COLOR_FORMATS,
  NGX_MAT_COLOR_FORMATS,
} from '@angular-material-components/color-picker';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { environment } from '@environments/environment';
// DEBUG: verificar carga de apiKey (eliminar después de validar)
console.log('[DEBUG] Firebase API Key cargada?', !!environment.apiKey, environment.apiKey ? environment.apiKey.substring(0, 8) + '...' : 'NULL');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withHashLocation()),
    provideCharts(withDefaultRegisterables()),
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    importProvidersFrom(
      BrowserModule,
      StoreModule.forRoot(ROOT_REDUCERS),
      StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
      EffectsModule.forRoot(),
      MatNativeDateModule
    ),
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'es-ES',
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideHttpClient(withInterceptors([spinnerInterceptor])),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() =>
      initializeApp({
        projectId: 'jobpointme-claro',
        appId: '1:938730525537:web:3e0c2a84f821ad8986ab20',
        databaseURL: 'https://jobpointme-claro-default-rtdb.firebaseio.com',
        storageBucket: 'jobpointme-claro.firebasestorage.app',
        apiKey: environment.apiKey,
        authDomain: 'jobpointme-claro.firebaseapp.com',
        messagingSenderId: '938730525537',
      })
    ),
    provideAuth(() => getAuth()),
    provideAnimationsAsync(),
  ],
};
